import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Utils } from "@react-awesome-query-builder/core";
var moment = Utils.moment;
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    config = props.config,
    valueFormat = props.valueFormat,
    readonly = props.readonly,
    customProps = props.customProps;
  var onChange = function onChange(e) {
    var value = e.target.value;
    if (value == "") value = undefined;
    setValue(value);
  };
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "date",
    value: value || "",
    disabled: readonly,
    onChange: onChange
  }, customProps));
});